<template>
    <div class="flex flex-col items-center justify-center">
    </div>
</template>
  
  
  <script>
  
  export default {
    created() {
      this.$vs.loading();
      const isLoggedIn = localStorage.getItem(
        `${process.env.VUE_APP_ACCESS_TOKEN_NAME}LoggedIn`
      );
      if(!isLoggedIn){
        const requestId = this.$route.params.requestId;
        this.$router.push({ 
          path: '/login',
          query: { 
            requestId,
          }, 
        });
      }
      this.$vs.loading.close();
    },
  };
  </script>
  
  <style lang="scss">
  </style>
  